import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'lum-purchase-order-item-input',
  templateUrl: './purchase-order-item-input.component.html',
  styleUrls: ['./purchase-order-item-input.component.scss'],
})
export class PurchaseOrderItemInputComponent {
  @Input()
  readonly :boolean = false;

  @Input()
  hasComparedValue :boolean = false;

  @Input()
  value :number = 0;

  @Input()
  comparedValue :number = 0;

  @Input()
  control :UntypedFormControl = new UntypedFormControl();

  @Input()
  withDecimal :boolean = false;

  @Output()
  toggleEvent :EventEmitter<void> = new EventEmitter<void>();

  @Output()
  inputEvent :EventEmitter<string> = new EventEmitter<string>();

  onToggleInput() :void {
    this.toggleEvent.emit();
  }

  onInput(event :Event) {
    const inputValue = (event.target as HTMLInputElement).value;
    this.inputEvent.emit(inputValue);
  }
}
